export default __webpack_public_path__ + "static/media/img_baseCottonEars_cotton_p.1b5566e0.jpg";